<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9443 6.19531C12.9722 6.19531 13.8056 7.02883 13.8057 8.05664V11.9453C13.8057 12.9732 12.9722 13.8066 11.9443 13.8066H8.05566C7.02786 13.8066 6.19434 12.9731 6.19434 11.9453V8.05664C6.1944 7.02887 7.0279 6.19538 8.05566 6.19531H11.9443ZM8.05566 7.69531C7.85632 7.69538 7.6944 7.8573 7.69434 8.05664V11.9453C7.69434 12.1447 7.85628 12.3066 8.05566 12.3066H11.9443C12.1438 12.3066 12.3057 12.1447 12.3057 11.9453V8.05664C12.3056 7.85726 12.1437 7.69531 11.9443 7.69531H8.05566Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 1.19531C14.8631 1.19537 18.8056 5.13789 18.8057 10.001C18.8056 14.8641 14.8631 18.8066 10 18.8066C5.13692 18.8066 1.19439 14.8641 1.19434 10.001C1.1944 5.1379 5.13692 1.19538 10 1.19531ZM10 2.69531C5.96535 2.69538 2.6944 5.96633 2.69434 10.001C2.69439 14.0356 5.96535 17.3066 10 17.3066C14.0347 17.3066 17.3056 14.0356 17.3057 10.001C17.3056 5.96632 14.0347 2.69537 10 2.69531Z"
            fill="currentColor"
        />
    </svg>
</template>
